module.exports = __webpack_public_path__ + "img/other-sensors.11bad428.svg";